import { render, staticRenderFns } from "./Notificacao.vue?vue&type=template&id=a0a812f8&scoped=true&"
import script from "./Notificacao.vue?vue&type=script&lang=js&"
export * from "./Notificacao.vue?vue&type=script&lang=js&"
import style0 from "./Notificacao.vue?vue&type=style&index=0&id=a0a812f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a812f8",
  null
  
)

export default component.exports